import { init } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"
import { unbindOriginalSearch, speechToText } from './helpers'

import "./styles/index.css"

unbindOriginalSearch("form.predictive-search")

// add swiper in
const swiperLink = document.createElement("link");
swiperLink.rel = 'stylesheet';
swiperLink.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';

const swiperScript = document.createElement("script");
swiperScript.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";

document.querySelector('head').appendChild(swiperLink);
document.querySelector('head').appendChild(swiperScript);

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    // categoryComponent: Serp,
    inputCssSelector: "input.search__input.form-control",
    contentCssSelector: "#MainContent",
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    // Uncomment to redirect to search page instead of rendering on the same page
    serpPath: '/search',

    // Uncomment to redirect to search page instead of rewriting browser history
    // serpPathRedirect: true,
    serpQuery: {
        products: {
            fields: [
                "productId",
                "url",
                "name",
                "imageUrl",
                "alternateImageUrls",
                "tags1",
                "thumbUrl",
                "description",
                "brand",
                "availability",
                "price",
                "priceText",
                "listPrice",
                "ratingValue",
                "reviewCount",
                'customFields.key', 'customFields.value'
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId",
                "url",
                "name",
                "imageUrl",
                "alternateImageUrls",
                "thumbUrl",
                "brand",
                "availability",
                "price",
                "priceText",
                "listPrice",
                "ratingValue",
                "reviewCount"
            ],
            size: defaultConfig.autocompleteProductsSize
        },
        keywords: {
            fields: ["keyword", "_highlight.keyword"],
            size: defaultConfig.autocompleteKeywordsSize,
            facets: ["*"]
        }
    },
    compressUrlParameters: true,
    fallback: true,
    // // Uncomment for Category Merchandising
    // categoryCssSelector: '#MainContent',
    // categoryCssSelector: '.collection-contents .page-banner-content-box + div.container',
    categoryCssSelector: '.collection-contents .collection-container--results',
    // collection-container--results
       categoryQuery() {
        return {
            name: 'serp',
            products: {
                categoryId: this.categoryId(),
                categoryPath: this.categoryPath(),
                size: defaultConfig.serpSize,
                from: 0,
            }
        }
    },
}).then(function() {
    speechToText('.search__speech', '.nosto-autocomplete-wrapper > input.search__input');

    // Moving this to products.jsx, since we have infinite scroll, when the page reloads with new products with need to run this again 
    // function swatchElements(section = document) {
    //     let swatchElements = section.querySelectorAll("[data-swatch]");
    //     Array.from(swatchElements).forEach(function(element) {
    //         initQuickviewAction(element);
    //     });
    // }
    // // Init Quickview
    // let swatchCheck = setInterval(function() {
    //     if(document.querySelectorAll(".ns-serp [data-swatch]").length > 0) {
    //         swatchElements();
    //         clearInterval(swatchCheck);
    //     }
    // }, 500)


    // // Init Quickview
    // let quickviewCheck = setInterval(function() {
    //     if(document.querySelectorAll(".ns-serp [data-quick-view]").length > 0) {
    //         quickviewElements();
    //         clearInterval(quickviewCheck);
    //     }
    // }, 500)

    // Badge Flash
    // setInterval(() => {
    //     jQuery(".tags .custom-badge").toggleClass("fadein-active");
    // }, 4000)

    setInterval(() => {
        const tagsContainersMultipleTags = document.querySelectorAll(".product-card-badges.tags");
        tagsContainersMultipleTags.forEach(tagContainer => {
            // find current and next tag idx
            let currentActiveTagIdx;
            const tags = tagContainer.querySelectorAll(".tags .custom-badge");
            let noActiveTags = true;
            tags.forEach((tag, idx)=> {
                if (tag.classList.contains('fadein-active')) {
                    currentActiveTagIdx = idx;
                    noActiveTags = false;
                }
            })
            if (noActiveTags == true) {
                tags[0].classList.add('fadein-active');
            } else {
                let nextActiveTagIdx = (currentActiveTagIdx + 1) % tags.length;
                tags[currentActiveTagIdx].classList.remove('fadein-active');
                tags[nextActiveTagIdx].classList.add('fadein-active');
            }
        })
    }, 4000)
})


